// What the post's embeds show. REAL skills, as the shelf lists them on
// 2026-09-19 — real titles, authors, versions and links — so every card in the
// post opens the real page and every copy copies a link that works.

export interface EmbedSkill {
  slug: string;
  title: string;
  description: string;
  category: string;
  version?: string;
  tags: string[];
  by: string;
  host?: string;
  broughtBy?: string;
  updated: string;
}

export const SITE = "https://innernet.live";

export const SHELF: EmbedSkill[] = [
  { slug: "quiet-interface", title: "quiet interface", description: "a complete method for designing and building calm, coherent interfaces: one colour source, no boxes, motion that settles rather than pops.", category: "design", version: "1.0.0", tags: ["design", "ui", "motion"], by: "innernet", updated: "2026-07-26" },
  { slug: "anthropic-frontend-design", title: "frontend design", description: "an opinionated way to make interfaces that don't read as templates: palette, type, layout, and one deliberate risk.", category: "design", tags: ["design", "ui", "frontend"], by: "anthropic", host: "github.com", updated: "2026-09-09" },
  { slug: "superpowers-systematic-debugging", title: "systematic debugging", description: "a method for bugs and failing tests: reproduce, isolate, understand, and only then propose a fix.", category: "code", tags: ["debugging", "code", "process"], by: "obra", host: "github.com", updated: "2026-09-09" },
  { slug: "supabase-postgres-best-practices", title: "postgres best practices", description: "postgres rules from supabase for any postgres: schema, migrations, rls, indexes, functions, queues, vectors, slow queries.", category: "code", version: "1.1.1", tags: ["code", "engineering", "api"], by: "supabase", host: "github.com", updated: "2026-09-09" },
  { slug: "michaelshimeles-before-and-after", title: "before-and-after", description: "captures before/after screenshots of web pages or elements for visual comparison. use for screenshot comparisons, pr screenshots, or documenting ui changes.", category: "code", version: "1.0.0", tags: ["screenshots", "visual-diff", "ui"], by: "michaelshimeles", host: "github.com", broughtBy: "a member", updated: "2026-09-17" },
  { slug: "phuryn-create-prd-2", title: "create prd", description: "create a product requirements document using a comprehensive 8-section template covering problem, objectives, segments, value propositions, solution, and release planning.", category: "documents", version: "1.0.0", tags: ["product", "prd", "specs"], by: "phuryn", host: "github.com", broughtBy: "a member", updated: "2026-09-18" },
  { slug: "chrisvoncsefalvay-d3-viz-2", title: "d3 viz", description: "creating interactive data visualisations using d3.js: custom charts, graphs, network diagrams, geographic visualisations, anything svg that needs fine-grained control.", category: "code", version: "1.0.0", tags: ["d3", "charts", "dataviz"], by: "chrisvoncsefalvay", host: "github.com", broughtBy: "a member", updated: "2026-09-18" },
  { slug: "conorbronsdon-avoid-ai-writing-2", title: "avoid ai writing", description: "audit and rewrite content to remove ai writing patterns, with a detect-only mode, an edit-in-place mode, and an optional voice profile.", category: "writing", version: "3.35.0", tags: ["editing", "voice", "style"], by: "conorbronsdon", host: "github.com", broughtBy: "a member", updated: "2026-09-18" },
  { slug: "skill-format", title: "the skill format", description: "the document class for a shareable skill: one markdown file, a manifest at the top, a link you can hand to any ai.", category: "documents", version: "1.2.0", tags: ["skills", "format", "spec"], by: "innernet", updated: "2026-09-17" },
];

/** the forms a skill arrives in, and what innernet reads each one as —
 *  verified live against these exact repos on 2026-09-18. */
export const BRING_EXAMPLES = [
  {
    said: "npx skills add anthropics/skills --skill frontend-design",
    kind: "an install line",
    lands: "github.com/anthropics/skills · skills/frontend-design",
    title: "frontend design",
    by: "anthropics",
    note: "read as the folder it names. nothing is installed, and no node is needed.",
  },
  {
    said: "https://skills.sh/mattpocock/skills/grill-me",
    kind: "a skills.sh page",
    lands: "github.com/mattpocock/skills · skills/productivity/grill-me",
    title: "grill-me",
    by: "mattpocock",
    note: "found in its repo, even where the folder hides one level down.",
  },
  {
    said: "npx skills add mattpocock/skills",
    kind: "a whole library",
    lands: "github.com/mattpocock/skills · 38 skills",
    title: "38 skills, listed",
    by: "mattpocock",
    note: "a library comes back as a list, so your ai can ask which ones you want and bring them in one go.",
  },
  {
    said: "https://x.com/…/status/…",
    kind: "a post",
    lands: "the repo the post points at",
    title: "the skill behind the post",
    by: "whoever wrote the repo",
    note: "one hop from a post on x or reddit to the repo it links. the repo's owner is the author; whoever posted it is kept as where it was found.",
  },
];
